import type { StudyStart } from "@ca/shared";
import { useEffect, useRef } from "react";
import { StudyTracker } from "./study-tracker.ts";
export function useStudy(uid: string, refId: string, activity: "test" | "part", enabled: boolean) {
  const tracker = useRef<StudyTracker | null>(null);
  useEffect(() => {
    if (!enabled) return;
    const current = new StudyTracker(uid, {
      activity,
      refType: "attempt",
      refId,
      refKey: null,
      device: "web",
    });
    tracker.current = current;
    current.start();
    return () => {
      current.stop();
      if (tracker.current === current) tracker.current = null;
    };
  }, [uid, refId, activity, enabled]);
  return () => tracker.current?.settle() ?? Promise.resolve();
}

export function useRevisionStudy(
  uid: string,
  refType: StudyStart["refType"],
  refId: string | undefined,
  activity: StudyStart["activity"],
  refKey: string | null = null,
) {
  const tracker = useRef<StudyTracker | null>(null);
  useEffect(() => {
    if (!refId) return;
    const current = new StudyTracker(uid, { activity, refType, refId, refKey, device: "web" });
    tracker.current = current;
    current.start();
    return () => {
      current.stop();
      if (tracker.current === current) tracker.current = null;
    };
  }, [uid, refType, refId, activity, refKey]);
  return () => tracker.current?.settle() ?? Promise.resolve();
}
